


const loanSeniority = value => {
    value = +value;
    switch (value) {
        case 1:
            return {value, display: 'Senior'};
        case 2:
            return {value, display: 'Secondary'};
        case 3:
            return {value, display: 'Junior'};
        default:
            return {value, display: ''};
    }

};



export default {
    loanSeniority
}
